import React, {useEffect,useRef} from 'react';
export interface AutocompleteItem {label:string;id?:string}
interface AutocompleteMenuProps {
    position:{top:number;left:number};items:AutocompleteItem[];selectedIndex:number;
    listId:string;label:string;onSelect:(item:AutocompleteItem)=>void;onClose:()=>void;
}
/** The active text editor owns keyboard input; this popup only presents choices. */
export const AutocompleteMenu:React.FC<AutocompleteMenuProps>=({position,items,selectedIndex,listId,label,onSelect,onClose})=>{
    const menuRef=useRef<HTMLDivElement>(null);
    useEffect(()=>{
        const outside=(event:MouseEvent)=>{if(menuRef.current&&!menuRef.current.contains(event.target as Node))onClose();};
        document.addEventListener('mousedown',outside);
        return ()=>document.removeEventListener('mousedown',outside);
    },[onClose]);
    useEffect(()=>{menuRef.current?.querySelector(`[aria-selected="true"]`)?.scrollIntoView({block:'nearest'});},[selectedIndex]);
    if(!items.length)return null;
    return <div ref={menuRef} id={listId} role="listbox" aria-label={label}
        className="fixed z-[10000] w-64 max-h-64 overflow-y-auto bg-zinc-900 border border-white/10 rounded-lg shadow-2xl py-1"
        style={{top:position.top,left:position.left}}>
        {items.map((item,index)=><button key={item.label} id={`${listId}-${index}`} role="option" aria-selected={index===selectedIndex}
            tabIndex={-1} onMouseDown={event=>event.preventDefault()} onClick={()=>onSelect(item)}
            className={`w-full text-left px-3 py-2 text-sm ${index===selectedIndex?'bg-indigo-500/20 text-indigo-300':'text-zinc-400 hover:bg-white/5 hover:text-zinc-200'}`}>
            {item.label}
        </button>)}
    </div>;
};
